<template>
    <div class="view-with-bar">
        <div :class="{ 'bar-container': true, 'shrunk-bar': collapsed }">
            <slot name="bar"/>
        </div>
        <div :class="{ collapser: true, 'shrunk-collapser': collapsed} " @click="() => collapsed = !collapsed">
            <icon :icon="['fal', collapsed ? 'chevron-right' : 'chevron-left']"></icon>
        </div>
        <div :class="{ 'view-container': true, 'shrunk-container': collapsed }">
            <router-view :key="this.$router.currentRoute.fullPath"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ViewWithBar",
        data: function () {
            return {
                collapsed: false
            }
        }
    }
</script>

<style lang="scss" scoped>
.view-with-bar {
    height: 100%;
}

.collapser {
    cursor: pointer;
    position: absolute;
    left: 240px;
    top: 46px;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    color: var(--input-active-font-color);
    background: linear-gradient(to bottom, var(--accent-color) 5%, #C85858 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 0;
    margin: 0 0;
    font-size: 10px;
    transition: all 0.2s linear;
    z-index: 1;
}

.shrunk-collapser {
    background: var(--card-background-color);
    left: -10px;
}
.bar-container {
    position: fixed;
    height: 100vh;
    width: 250px;
    transition: all 0.2s linear;
    z-index: 0;
}

.shrunk-bar {
    width: 0px;
    opacity: 0;
    margin: 0 0;
}

.view-container {
    position: fixed;
    width: calc(100vw - 300px);
    height: 100vh;
    left: 300px;
    padding: 20px;
    transition: all 0.2s linear;
    overflow-x: auto;
    scrollbar-width: thin;
    //scrollbar-color: var(--thumbBG) var(--scrollbarBG);
}

.view-container::-webkit-scrollbar {
    width: 13px;
    height: 13px;
}

.view-container::-webkit-scrollbar-track {
    background: var(--card-background-color);
}
.view-container::-webkit-scrollbar-thumb {
    background-color: #7a7b7c;
    border-radius: 6px;
    border: 3px solid #7a7b7c;
}

.shrunk-container {
    left: 50px;
    width: calc(100vw - 50px);
}

</style>
